import apiPaths from '../api-paths.js';

export default {
  index() {
    return axios.get(`${ apiPaths.PERSON }/company-type`);
  },
};
